export const TITLE_CARD_DEFAULTS = {
  currency: "COP",
  roomPlural: "Habitaciones",
  roomSingular: "Habitación",
  bathroomPlural: "Baños",
  bathroomSingular: "Baño",
  parkingPlural: "Parqueaderos",
  parkingSingular: "Parqueadero",
  areaUnit: "m²",
  elevatorPlural: "Ascensores",
  elevatorSingular: "Ascensor",
};
